// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-8-_ORfvu","morehNew":"morehNew-qmZdMXEq","more":"more-ckBxs0mE"};